export const defaultImageUrl = "https://cdn.moglix.com/p/uvwVBrwiX71Hg-xxlarge.jpg";